/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {EdisonServerDataParser} from "../EdisonServerDataParser";
import {IEdisonInitData} from "./IEdisonServerData";
import { IServerData } from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import { EdisonGameMode } from "../../gameMode/EdisonGameMode";

export class EdisonParsedInitData extends ParsedInitData {

    private _symbolsCollected:number[];
    private _stackedModeOverlay:boolean[];

    constructor(rawData:IEdisonInitData, dataParser:EdisonServerDataParser) {
        super(rawData, dataParser);

        this._symbolsCollected = dataParser.parseSymbolsCollected(rawData);
        this._stackedModeOverlay = dataParser.parseStackedModeOverlay(rawData);
    }

    public get symbolsCollected():number[] {
        return this._symbolsCollected;
    }

    public get stackedModeOverlay():boolean[] {
        return this._stackedModeOverlay;
    }

    protected isRespin(rawData:IServerData):boolean {
        return this.mode === EdisonGameMode.STACKED_RESPIN;
    }

    protected isNextRespin(rawData:IServerData):boolean {
        return this.nextMode === EdisonGameMode.STACKED_RESPIN;
    }
}